import React from 'react'
import { withLayout } from '../utils/hoc'
import { inject,observer } from 'mobx-react'

import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import { Link } from 'react-router-dom'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import T from 'i18n-react'
import Typography from 'material-ui/Typography'
import Divider from 'material-ui/Divider'
import route from '../stores/fetchconfig.json'

@inject('store') @observer
class Datenschutz extends React.Component {
  componentWillMount () {
   this.props.store.getAllMetadata()
  }

  render () {
    const { classes } = this.props, wpSettings = this.props.store.wpSettings

    return (
     <div>

      <AppBar position="static">
        <Toolbar>
         <Link to={route.endpoint + '/'} className={"unstyle-a " + classNames(classes.flex)}>
          <Typography type="title" color="inherit"> {wpSettings.title} </Typography>
         </Link>
        </Toolbar>
      </AppBar>

      <main className={classes.main}>

      <Typography type="display2"> {T.translate('datenschutz.title')} </Typography>

       <div className={classes.content}>

        <Typography component="p" type="title" className={classes.header}>
         {T.translate('disclaimer.disclaimContentTitle')}
        </Typography>
        <Typography component="p" type="subheading">
         {T.translate("disclaimer.disclaimContentDescription")}
        </Typography>

        <Typography component="p" type="title" className={classes.header}>
         {T.translate('disclaimer.disclaimLinksTitle')}
        </Typography>
        <Typography component="p" type="subheading">
         {T.translate("disclaimer.disclaimLinksDescription")}
        </Typography>

        <Typography component="p" type="title" className={classes.header}>
         {T.translate('disclaimer.dataProtectionTitle')}
        </Typography>
        <Typography component="p" type="subheading">
         {T.translate("disclaimer.dataProtectionDescription")}
        </Typography>

        <Typography component="p" type="title" className={classes.header}>
         {T.translate('disclaimer.googleAnalyticsTitle')}
        </Typography>
        <Typography component="p" type="subheading">
         {T.translate("disclaimer.googleAnalyticsDescription")}
        </Typography>


       </div>

      </main>

     </div>
    )
  }
}

const styles = theme => ({
  flex: {
    display:'flex'
  },
  main:{
    padding:15,
    'padding-top':30
  },
  content:{
    'padding-top':50,
    'padding-left':50
  },
  icon:{
    'vertical-align':'middle',
    'margin-right':10
  },
  entry:{
    'margin-bottom':10
  },
  divider:{
    'margin-top':20,
    'margin-bottom':20,
    width:250
  },
  header:{
    'margin-left':-20,
    'padding-bottom':20,
    'padding-top':20
  }
})


export default withStyles(styles, { withTheme: true })(withLayout(Datenschutz))



// WEBPACK FOOTER //
// ./src/components/datenschutz.js